import * as React from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { TApiQuestionEntity } from '../../types/Survey';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import SurveyTranslation from '../survey/SurveyTranslation';

interface IQuestionHelpTextModal {
  modalOpen: boolean;
  setModalOpen: (value: React.SetStateAction<boolean>) => void;
  question: TApiQuestionEntity;
}

const useStyles = makeStyles((theme: Theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const QuestionHelpTextModal: React.FC<IQuestionHelpTextModal> = ({
  modalOpen,
  setModalOpen,
  question,
}): JSX.Element => {
  const classes = useStyles({});

  return (
    <Dialog
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle>
        <IconButton
          aria-label='close'
          className={classes.closeButton}
          onClick={() => setModalOpen(false)}
          size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <p dangerouslySetInnerHTML={{ __html: question.helpText }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setModalOpen(false)} color='primary' autoFocus>
          <SurveyTranslation translate={'survey.question.help.modal.close'} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuestionHelpTextModal;
